var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.texts.start)),_c('span',{staticClass:"v-list-item__mask"},[_vm._v(_vm._s(_vm.texts.middle))]),_vm._v(_vm._s(_vm.texts.end))])
}
var staticRenderFns = []

export { render, staticRenderFns }